import React, { useState, createContext, useContext, useEffect } from 'react';

import { apiUrl, apiSocket } from '../config';
import { useAuth } from './Auth';

interface IPagesContextData {
  menu: Array<Record<string, any>>;
  pages: Array<Record<string, any>>;
  readPages: Function;
}

const PagesContext = createContext<IPagesContextData>({} as IPagesContextData);

const PagesProvider: React.FC = ({ children }) => {
  const [pages, setPages] = useState([
    { tag: 'home', status: 2 },
    { tag: 'patrocinadores', status: 1 },
    { tag: 'programacao', status: 1 },
    { tag: 'sobre', status: 1 },
    { tag: 'palestrantes', status: 1 },
    { tag: 'login', status: 2 },
    { tag: 'inscricao', status: 2 },
  ]);

  const [menu, setMenu] = useState([
    {
      title: 'HOME',
      target: '/',
      targetID: '',
      fluid: 1,
      external: 1,
      status: 2,
    },
    {
      title: 'PROGRAMAÇÃO',
      target: '/',
      targetID: 'programacao',
      fluid: 2,
      external: 1,
      status: 2,
    },
    {
      title: 'INSCRIÇÃO',
      target: '/inscricao',
      targetID: '',
      fluid: 1,
      external: 1,
      status: 1,
    },
    {
      title: 'SOBRE',
      target: '/',
      targetID: 'sobre',
      fluid: 2,
      external: 1,
      status: 2,
    },
    {
      title: 'GALERIA DE FOTOS',
      target: '/',
      targetID: 'galerias',
      fluid: 2,
      external: 1,
      status: 1,
    },
    {
      title: 'BOLETINS INFORMATIVOS',
      target: '/',
      targetID: 'boletins',
      fluid: 2,
      external: 1,
      status: 1,
    },

    {
      title: 'PALESTRANTES',
      target: '/',
      targetID: 'palestrantes',
      fluid: 2,
      external: 1,
      status: 1,
    },

    {
      title: 'SEJA UM PATROCINADOR',
      target: '/seja_um_patrocinador',
      targetID: '',
      fluid: 1,
      external: 1,
      status: 1,
    },
    {
      title: 'ESTANDES VIRTUAIS',
      target: '/',
      targetID: 'expositores',
      fluid: 2,
      external: 1,
      status: 2,
    },
  ]);

  const readPages = () => {
    const pagesResponse = pages.reduce((prev, elem) => {
      prev[elem.tag] = elem;

      return prev;
    }, {});

    return pagesResponse;
  };

  return (
    <PagesContext.Provider value={{ pages, menu, readPages }}>
      {children}
    </PagesContext.Provider>
  );
};

function usePages(): IPagesContextData {
  const context = useContext(PagesContext);

  if (!context) {
    throw new Error('usePages must be used within a PagesProvider');
  }

  return context;
}

export { usePages, PagesProvider };
